import { useEffect, useRef } from 'react';
import { shouldSuppressPaletteClick } from './palette-activation-guard';

export function usePaletteItemActivate(
  onActivate: () => void,
  isDragging: boolean,
): () => void {
  const ignoreClickRef = useRef(false);

  useEffect(() => {
    if (isDragging) {
      ignoreClickRef.current = true;
    }
  }, [isDragging]);

  return () => {
    if (shouldSuppressPaletteClick()) {
      return;
    }
    if (ignoreClickRef.current) {
      ignoreClickRef.current = false;
      return;
    }
    onActivate();
  };
}
